import type {StripeConnect} from '../setupStripeConnect';

export const isWindowStripeConnectDefinedCorrectly = (
  stripeConnect: unknown,
): stripeConnect is StripeConnect => {
  // We only consider `StripeConnect` defined (afer connect.js loaded) if `init` is a function
  // Note that HTML markup like:
  // <a id="StripeConnect"><a id="StripeConnect" name="init" href="doyensec"></a></a> in the <head> of the page
  // can end up "contaminating" the window.StripeConnect object and cause issues in connect.js initialization
  const isInitDefined = !!(
    stripeConnect &&
    typeof stripeConnect === 'object' &&
    'init' in stripeConnect &&
    typeof stripeConnect.init === 'function'
  );

  // Some platforms initialize StripeConnect with an onLoad function. In that case, we also consider the StripeConnect object defined and leave it as is
  const isOnLoadDefined = !!(
    stripeConnect &&
    typeof stripeConnect === 'object' &&
    'onLoad' in stripeConnect &&
    typeof stripeConnect.onLoad === 'function'
  );

  // If the `StripeConnect` object is an HTMLCollection or HTMLElement, we don't consider it correctly defined
  const isHtmlCollection =
    stripeConnect instanceof HTMLCollection ||
    stripeConnect instanceof HTMLElement;

  return (isInitDefined || isOnLoadDefined) && !isHtmlCollection;
};
